// eslint-disable-next-line
const itemPath = require.context('../options', false, /\.js$/)
const items = itemPath.keys().map((path) => {
  const item = itemPath(path)
  const fileName = path.match(/.\/(\S*).js/) || ''
  return Object.assign(item.default || item, { mapKey: fileName && fileName[1] })
}) as any[]

export default items
